import {Component, OnInit} from "@angular/core";
import {ViewManagerService} from "../../../services/view-manager.service";
import {TenantsService} from "../tenants.service";
import {Space} from "../../../model/tenants.model";

@Component({
  selector: "admin-tenants-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"]
})
export class AdminTenantsListComponent implements OnInit {

  constructor(
    private tenantsService: TenantsService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnInit(): void {
  }

  get spaces(): Space[] {
    return this.tenantsService.spaces;
  }

  manage(space: Space) {
    this.tenantsService.manage(space.code!)
  }

  delete(space: Space) {

  }

}
